module.exports = __webpack_public_path__ + "img/headshot-andrea-maida@1x.33f37d05.jpg";